export default __webpack_public_path__ + "static/media/step5-icon.092b5b91.svg";